// @flow

// Vendors
import React, { useState } from 'react';
import classnames from 'classnames';

// Types
import { FormType } from '../../types';

const Form = ({
  initialValues = {},
  initialErrors = {},
  onSubmit,
  render,
  className,
  ...props
}: FormType) => {
  const [values, setValues] = useState(initialValues);
  const [errors, setErrors] = useState(initialErrors);
  const [isSubmitting, setSubmitting] = useState(false);

  const resetForm = () => {
    setValues({});
    setErrors({});
    setSubmitting(false);
  };

  const setValue = (name: string, value: any) =>
    setValues({ ...values, [name]: value });

  const setError = (name: string, value: any) =>
    setErrors({ ...errors, [name]: value });

  const getValue = name => values[name];

  const getValues = () => values;

  const getError = name => errors[name];

  const getErrors = () => errors;

  const handleChange = event => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    setValue(name, value);
  };

  const formProps = {
    values,
    getValue,
    getValues,
    setValue,
    setValues,
    errors,
    getError,
    getErrors,
    setError,
    setErrors,
    isSubmitting,
    setSubmitting,
    resetForm,
    handleChange
  };

  const handleSubmit = event => {
    event.preventDefault();
    setErrors({});
    onSubmit(formProps);
  };

  return (
    <form
      className={classnames('form', className)}
      onSubmit={handleSubmit}
      {...props}
    >
      {render(formProps)}
    </form>
  );
};

export default Form;
